import Button from "components/base/Button";
import { Select } from "components/base/Form";
import { useState } from "react";

const CreateProductsForSaleView = ({ originalGTMProject, nextHandler }) => {
  const gtmPackagings = originalGTMProject.packagings.map((i) => ({
    basic: JSON.parse(i.basic),
    item: JSON.parse(i.item),
  }));
  const startUpPackagingInfos = JSON.parse(
    originalGTMProject.startUpProject.data,
  ).packagings;

  const [selectedGtmPackagingIndex, setSelectedGtmPackagingIndex] = useState(0);
  const [selectedStartUpPackagingIndex, setSelectedStartUpPackagingIndex] =
    useState(0);

  const selectedGtmPackaging = gtmPackagings[selectedGtmPackagingIndex];
  const selectedStartUpPackaging =
    startUpPackagingInfos[selectedStartUpPackagingIndex];

  return (
    <div className="text-sm">
      <div className="space-y-4">
        <div>
          <label>Packaging: </label>
          <Select
            className="ml-3"
            value={selectedGtmPackagingIndex}
            onChange={(e) =>
              setSelectedGtmPackagingIndex(Number(e.target.value))
            }
          >
            {gtmPackagings.map((packaging, index) => (
              <option key={index} value={index}>
                {packaging.basic.name}
              </option>
            ))}
          </Select>
        </div>

        <div>
          <label>Product BOM: </label>
          <Select
            className="ml-3"
            value={selectedStartUpPackagingIndex}
            onChange={(e) =>
              setSelectedStartUpPackagingIndex(Number(e.target.value))
            }
          >
            {startUpPackagingInfos.map((packaging, index) => (
              <option key={index} value={index}>
                Packaging Option #{index + 1}. {packaging.packagingType},{" "}
                {packaging.bomQty} / Outer Carton
              </option>
            ))}
          </Select>
        </div>
      </div>

      <Button
        className="mt-8"
        primary
        onClick={() =>
          nextHandler({
            selectedStartUpPackaging,
            selectedGtmPackaging,
          })
        }
      >
        Next
      </Button>
    </div>
  );
};

export default CreateProductsForSaleView;
